import React from "react";
import { SortableItem } from "../../organisms/sortable-item";

class SortableMaterial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
  }

  componentDidMount() {}

  render() {
    const { items } = this.props;
    var listItems = items.map((item, i) => {
      return (
        <SortableItem
          className="col-md-10 div-item-banner"
          key={item.materialComunicacaoId}
          onSortItems={this.props.onSortItems}
          items={items}
          sortId={i}
        >
          <div className="row" style={{ height: "100" }}>
            <div className="col-md-1">{i + 1}</div>
            <div className="col-md-2">
              <img
                style={{
                  maxHeight: 50,
                  maxWidth: 100,
                }}
                src={item.urlImagem}
              />
            </div>
            <div className="col-md-6"> {item.nome}</div>
          </div>
        </SortableItem>
      );
    });

    return <div className="sortable-list">{listItems}</div>;
  }
}

export default SortableMaterial;
